module.exports = __webpack_public_path__ + "img/equipment.05ed8eac.png";